import React from "react";
import "./MoreInformation.css";
import moreImage from "../../assets/zach-wear-zOoiOzayjK4-unsplash.jpg";

const MoreInformation = () => {
  return (
    <div className="more-container">
      <div className="more-content">
        <h2>Same as giving filming grants:</h2>
        <p>
          No. When we pick a project, we determine what it needs. We film it
          ourselves and we carry out all the distribution.
        </p>

        <h2>Can producers request funding?</h2>
        <p>
          No, at this time we choose all the projects and carry out the
          production ourselves.
        </p>

        <h2>Production timelines</h2>
        <p>
          Once a project has been fully funded, it takes about 3 weeks for the
          entire filming project to be completed.
        </p>

        <h2>Do you focus on specific regions</h2>
        <p>No. We can film projects from anywhere in the world.</p>
      </div>
      <div className="more-image">
        <img src={moreImage} alt="Impact Story" />
      </div>
    </div>
  );
};

export default MoreInformation;
